import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";
import { useGetLocationData } from "~/hooks/locationData";
import { useStaffFilterData } from "~/shared/hooks/useStaffFilterData/useStaffFilterData";
import { getFilterFields } from "~/widgets/Filters/EducationalProgramsManagementFilter/model/config";

export const EducationalProgramsManagementFilter = () => {
  const { t } = useTranslation();
  const { positionsSelectOptionsList, positionsSelectMethods } =
    useStaffFilterData();
  // Ключи фильтров приходят из URL и не описаны в типе useGetLocationData
  const { positions } = useGetLocationData() as Record<string, unknown>;

  // Должности, предзаполненные из программы (ids в URL), могут не попасть
  // на первую страницу опций селекта — догружаем их, чтобы показать label
  useEffect(() => {
    const ids = String(positions ?? "")
      .split(",")
      .filter(Boolean);
    if (ids.length) {
      positionsSelectMethods.ensureOptionsByIds(ids);
    }
  }, [positions]);

  // Значение мультиселекта в форме фильтра — массив строк (см. FilterField),
  // а instanceId в опциях — число; нормализуем value опций к строке,
  // иначе antd Select не находит опцию и показывает id вместо названия
  const positionsOptions = useMemo(
    () =>
      positionsSelectOptionsList.map((option) => ({
        ...option,
        value: String(option.value),
      })),
    [positionsSelectOptionsList],
  );

  const fields = useMemo(
    () =>
      getFilterFields({
        t,
        positionsSelectOptionsList: positionsOptions,
        positionsSelectMethods,
      }),
    [t, positionsOptions, positionsSelectMethods],
  );

  // hideActions: без кнопок «Показать»/«Сбросить» — фильтр на этой странице
  // не применяется, селект должностей только отображает подставленные значения
  return <Filter.Root fields={fields} alwaysShow hideActions columns={2} />;
};
